import { FC } from "react"
import { SchedulesDeleteSuccess } from "../../../module/schedules/containers/deleteSuccess"

export const SchedulesDeleteSuccessPage: FC = () => <SchedulesDeleteSuccess />
